<template>
  <vue-easy-lightbox
    :visible="visible"
    :imgs="images"
    :index="index"
    @hide="$emit('update:visible', false)"
  />
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox'

export default {
  components: {
    VueEasyLightbox
  },
  props: {
    visible: Boolean,
    images: Array,
    index: Number
  }
}
</script>
